import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, BehaviorSubject, Observable, Subject } from 'rxjs';

import { environment } from 'src/environments/environment';
import { IWayPoint } from '../itinenary-list/itinerary';
import { IItineraryRoute } from '../itinerary-route/itinerary-route';


// Interfaces and Enums
export interface Coordinates {
  latitude: string;
  longitude: string;
}

export interface WayPoint {
  id: number;
  /** Must not be more than 100 characters long. */
  itineraryName: string;
  latitude: string;
  longitude: string;
  latitudeDD?: string;
  longitudeDD?: string;
  latitudeDM?: string;
  longitudeDM?: string;
  latitudeDMS?: string;
  longitudeDMS?: string;
  /** Must not be more than 15 characters long. */
  elevation?: string;
  /** Must not be more than 100 characters long. */
  comment?: string;
  sequenceId: number;
  selectedCoordinate?: Coordinates;
}

export interface CsvSetting {
  delimiter: string; // Example field, add others as needed
  // Add additional properties based on the C# CsvSetting class
}

export enum ExportType {
  file = 'File',
  // Add additional export types as needed
}

export interface Itinerary {
  fileName: string;
  fileExtension: string;
  fileSize: number;
  exportTo: string;
  exportType: ExportType;
  wayPoints: WayPoint[];
  polygonPoints: WayPoint[];
  internalFileName: string;
  isCsv: boolean;
  containsPolygon: boolean;
  containsMultiPolyLine: boolean;
  polygonName: string;
  containsRoute: boolean;
  routeName: string;
  csvFileSetting: CsvSetting;
  splitWayPointsBy?: number;
  multiRoute: WayPoint[][];
  splitedRouteWayPoints: WayPoint[][];
}

export interface ExportFileData {
  fileName: string;
  fileExtension: string;
  type: string;
  url: string;
  contentGenerated: boolean;
  multiFileContent: Record<string, string>;
  itfFileContent?: Uint8Array;
}


@Injectable()
export class FileDataService {
  tempRoutefile: any[] = []
  deletePolygon: any;
  distanceWaypoint: any;
  routeMarker: any;
  routePopup: any;
  private onDragChange = new BehaviorSubject(null);
  dragChange$ = this.onDragChange.asObservable();

  private onClickMarker = new BehaviorSubject(null);
  selectrdMarker$ = this.onClickMarker.asObservable();

  private itinenaryData = new BehaviorSubject([]);
  currentItinenary$ = this.itinenaryData.asObservable();

  private fetchRoute = new Subject();
  isFetchRoute$ = this.fetchRoute.asObservable();

  private itineraryRouteData = new BehaviorSubject([]);
  currentItineraryRouteData$ = this.itineraryRouteData.asObservable();

  private itineraryName = new BehaviorSubject('');
  currentItineraryName$ = this.itineraryName.asObservable();



  //draging issue
  private onValidMark = new BehaviorSubject(null);
  isValidMark$ = this.onValidMark.asObservable();

  // Flag to determine if `ITINERARY DETAILS` in table is modified or not
  public isItinerayChanged: boolean = false;
  public isDrawPolygon = false;

  public isMultipleRowSelected: boolean = false;

  public isFitSelectRoute: boolean = false;

  public isSelectedMarker: boolean = false;

  public isDisableUTurn: boolean = false;

  currentUserName: any;

  public isTempRoute: boolean = false;

  public renameItinerary: boolean = false;

  public isItineraryListMarker: boolean = false;

  selectrdMarker(data: any) {
    this.onClickMarker.next(data);
  }


  changesOnDrag(data: any) {
    this.onDragChange.next(data);
  }
  //draging issue
  isValidMarker(data: boolean) {
    this.onValidMark.next(data);
  }
  changeItinenaryData(selectedData: IWayPoint[], isItineraryChanged: boolean) {
    this.isItinerayChanged = isItineraryChanged;
    this.itinenaryData.next(selectedData);
  }
  // Add the value if `Itinerary-Route` to be fetched or not
  addItineraryRoute(isRoute: boolean) {
    this.fetchRoute.next(isRoute)
  }
  // Push new  `Itinerary Route List`
  changeItineraryRouteData(routeData: IItineraryRoute[]) {
    this.itineraryRouteData.next(routeData);
  }
  changeItineraryName(name: string) {
    this.itineraryName.next(name);
  }

  private baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  // Values to be populated in Export File Format Dropdown
  getFileExtensions() {
    return this.http.get(`${this.baseUrl}/api/Converter/GetFileExtension`)
      .pipe(
        catchError(this.handleError)
      );
  }

  uploadFile(formData: FormData) {
    return this.http.post(`${this.baseUrl}/api/Converter/ImportFile`, formData)
      .pipe(
        catchError(this.handleError)
      );
  }

  downloadFile(fileData: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Converter/ExportFile`, fileData)
      .pipe(
        catchError(this.handleError)
      );
  }
  autoSaveFile(fileData: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Converter/autoSave`, fileData)
      .pipe(
        catchError(this.handleError)
      );
  }
  getLoginUsers() {
    return this.http.get(`${this.baseUrl}/api/Login/GetUsers`)
      .pipe(
        catchError(this.handleError)
      );
  }
  getAllFiles() {
    return this.http.get(`${this.baseUrl}/api/Converter/GetAllFiles`).pipe(catchError(this.handleError))
  }

  DeleteFiles(filename: any) {
    return this.http.delete(`${this.baseUrl}/api/Converter/deletefile?filename=${filename}`).pipe(catchError(this.handleError))
  }
  recoverFile(username: string) {
    return this.http.get(`${this.baseUrl}/api/Converter/recoveryFile?username=${username}`).pipe(catchError(this.handleError))
  }
  writeLog(message: any) {
    return this.http.get(`${this.baseUrl}/api/Login/writeLogs?message=${message}`)
      .pipe(
        catchError(this.handleError)
      );
  }
  getTokenExpiryDate(userid: any) {
    return this.http.get(`${this.baseUrl}/api/Login/GetTokenExpiryDate`, userid)
      .pipe(
        catchError(this.handleError)
      );
  }
  extendSessionTimeOut(arrTokenVals: any) {
    return this.http.post(`${this.baseUrl}/api/Login/ExtendSession`, arrTokenVals)
      .pipe(
        catchError(this.handleError)
      );
  }

  exportItinerary(payload: Itinerary): ExportFileData {
    const fileInfo: Itinerary = { ...payload };

    let fileData: ExportFileData = { 
      fileName: '', 
      fileExtension: '', 
      type: '', 
      url: '', 
      contentGenerated: false, 
      multiFileContent: {} 
    };

    try {
      fileData = this.exportItnFile(fileInfo, fileInfo.exportTo);
    } catch (error) {
      fileData.contentGenerated = false;
      console.error(error.message);
    }
    return fileData;
  }

  private exportItnFile(fileInfo: Itinerary, mapType: string | null = null): ExportFileData {
    const exportData: ExportFileData = { 
      fileName: fileInfo.fileName, 
      fileExtension: fileInfo.fileExtension, 
      type: mapType || '', 
      url: '', 
      contentGenerated: false, 
      multiFileContent: {} 
    };

    try {
      fileInfo.splitWayPointsBy = fileInfo.splitWayPointsBy === 1 ? 2 : fileInfo.splitWayPointsBy;

      if (
        !fileInfo.splitWayPointsBy ||
        fileInfo.splitWayPointsBy <= 0 ||
        fileInfo.splitWayPointsBy >= fileInfo.wayPoints.length
      ) {
        const itnFileData: string[] = [];

        fileInfo.wayPoints.forEach((wayPoint) => {
          const latitude = Math.floor(parseFloat(wayPoint.latitude) * 100000).toString();
          const longitude = Math.floor(parseFloat(wayPoint.longitude) * 100000).toString();
          itnFileData.push(
            `${longitude}|${latitude}|${wayPoint.itineraryName}|${(wayPoint.id - 1) * 2}|`
          );
        });

        exportData.multiFileContent[fileInfo.fileName] = itnFileData.join('\n');
      } else {
        let fileCounter = 0;
        let wayPointPerFileCount = 0;
        let itnFileSplitData: string[] = [];

        for (let i = 0; i < fileInfo.wayPoints.length; i++) {
          const wayPoint = fileInfo.wayPoints[i];
          const latitude = parseFloat(wayPoint.latitude).toString();
          const longitude = parseFloat(wayPoint.longitude).toString();

          itnFileSplitData.push(
            `${longitude}|${latitude}|${wayPoint.itineraryName}|${(wayPoint.id - 1) * 2}|`
          );

          wayPointPerFileCount++;

          if (
            wayPointPerFileCount === fileInfo.splitWayPointsBy ||
            wayPointPerFileCount === fileInfo.wayPoints.length ||
            i === fileInfo.wayPoints.length - 1
          ) {
            exportData.multiFileContent[
              `${fileInfo.fileName}_${++fileCounter}`
            ] = itnFileSplitData.join('\n');
            itnFileSplitData = [];
            wayPointPerFileCount = 0;
          }
        }
      }

      exportData.contentGenerated = true;
    } catch (error) {
      exportData.contentGenerated = false;
      console.error('Error in exportItnFile:', error);
    }

    return exportData;
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occured', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}`
      );
    }
    return throwError(error.error);
  }
}
